import { bookingResponse } from './bookingResponse';

export const ProviderMirai = {
  bookingResponse,
};
